var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { I18N } from "aurelia-i18n";
import { BindingEngine } from "aurelia-binding";
import { EventAggregator } from "aurelia-event-aggregator";
import { BrandingBase } from "../../../../branding/branding-base";
import { BrandClientService, TemplateType, BrandingType } from "../../../../../../../services/modules/brand-client.service";
import { NotificationClientService } from "../../../../../../../services/basics/notification-client.service";
import { TokenClient } from "../../../../../../../services/authentication/token-client.service";
import { BindingSignaler } from "aurelia-templating-resources";
var OverlayBrandingColors = /** @class */ (function (_super) {
    __extends(OverlayBrandingColors, _super);
    function OverlayBrandingColors(notificationService, i18N, brandClientService, bindingEngine, eventAggregator, tokenClient, bindingSignaler) {
        return _super.call(this, notificationService, i18N, brandClientService, bindingEngine, eventAggregator, tokenClient, bindingSignaler) || this;
    }
    OverlayBrandingColors.prototype.getTemplateType = function () {
        return TemplateType.Overlay;
    };
    OverlayBrandingColors.prototype.getBrandingType = function () {
        return BrandingType.Colors;
    };
    OverlayBrandingColors.prototype.getBrandDetails = function () {
        return {
            brandId: this.item.model.brandId,
            brandName: this.item.model.name,
            brandLanguages: Enumerable.from(this.item.model.brandLanguages).select(function (x) { return x.languageId; }).toArray()
        };
    };
    OverlayBrandingColors.prototype.shouldNotFilter = function () {
        return true;
    };
    OverlayBrandingColors = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            BrandClientService, BindingEngine,
            EventAggregator, TokenClient, BindingSignaler])
    ], OverlayBrandingColors);
    return OverlayBrandingColors;
}(BrandingBase));
export { OverlayBrandingColors };
